import React, { useState, useEffect } from "react";
import "./styles.css";
import GetInfoService from "../../../../service/GetInfoService";
import { cloudinaryInstance } from "../../../../utilities/Cloudinary/cloudinaryInstance";
import { locale } from "../../../../utilities/locale/locale";
import { Skeleton } from "primereact/skeleton";
import BannerCarousel from "../BannerCarousel/BannerCarousel";
import SubBannerCarousel from "../BestDeals/SubBannerCarousel/SubBannerCarousel";

const PrimaryBanner = () => {
  const [primaryBanners, setPrimaryBanners] = useState([]);
  const [subBannerOne, setSubBannerOne] = useState([]);
  const [subBannerTwo, setSubBannerTwo] = useState([]);
  const [subBannerThree, setSubBannerThree] = useState([]);
  const [loading, setLoading] = useState(true);
  const [delays, setDelays] = useState();

  const getInfoService = new GetInfoService();

  const bannerLang = {
    pt: "imageDesktopPortuguese",
    en: "imageDesktopEnglish",
    it: "imageDesktopItalian",
    es: "imageDesktopSpanish",
  };

  const formatBanners = (banner, banners) => {
    let allBanners = [];

    if (banner) allBanners = [banner];

    if (banners?.length > 0) allBanners = [...allBanners, ...banners];

    if (allBanners?.length === 0) return [];

    return allBanners
      .filter((banner) => banner?.showImage)
      .map((banner) => ({
        ...banner,
        bgImg: cloudinaryInstance.image(banner?.[bannerLang[locale]]).format("webp").toURL(),
      }));
  };

  useEffect(() => {
    const getBanners = async () => {
      const response = await getInfoService.getConfiguration();

      setDelays({ main: response.result.delayMainBanner, sub: response.result.delaySubBanners });

      const mainBanners = formatBanners(response.result.mainBanner, response.result.mainBanners);

      setPrimaryBanners(mainBanners);

      const subBanners1 = formatBanners(response.result.subBanner1, response.result.subBanners1);

      setSubBannerOne(subBanners1);

      const subBanners2 = formatBanners(response.result.subBanner2, response.result.subBanners2);

      setSubBannerTwo(subBanners2);

      const subBanners3 = formatBanners(response.result.subBanner3, response.result.subBanners3);

      setSubBannerThree(subBanners3);

      setLoading(false);
    };

    getBanners();
  }, []);

  return (
    <>
      {loading ? (
        <div className="md:mt-5">
          <Skeleton height="400px" />
          <div className="flex gap-4 mt-4">
            <Skeleton height="200px" />
            <Skeleton height="200px" />
            <Skeleton height="200px" />
          </div>
        </div>
      ) : (
        <>
          <div className="md:mt-5 overflow-hidden primary-banner-responsive">
            {primaryBanners.length > 0 && (
              <BannerCarousel items={primaryBanners} timeToChangeImg={delays.main} />
            )}
          </div>

          <div className="containerCardBanners overflow-hidden gap-4 mt-4 w-full grid-nogutter">
            {subBannerOne.length > 0 && (
              <SubBannerCarousel items={subBannerOne} timeToChangeImg={delays.sub} />
            )}

            {subBannerTwo.length > 0 && (
              <SubBannerCarousel items={subBannerTwo} timeToChangeImg={delays.sub} />
            )}

            {subBannerThree.length > 0 && (
              <SubBannerCarousel items={subBannerThree} timeToChangeImg={delays.sub} />
            )}
          </div>
        </>
      )}
    </>
  );
};

export default PrimaryBanner;
